import React from 'react'
import { useLazyQuery, useQuery } from '@apollo/client'
import {
  SortDirectionEnum,
  GroupsFilterInput,
  UsersFilterInput,
  Groups,
  GroupsVariables,
} from '../../types'
import { GROUPS } from './operations'

export type Sorter = {
  sortBy: string
  direction: SortDirectionEnum
}

interface Props {
  filter?: GroupsFilterInput
  sorter?: Sorter
  page?: number
  pageLength?: number
  membersFilter?: UsersFilterInput
  membersSorter?: Sorter
  membersPage?: number
  membersPageLength?: number
  skip?: boolean
}

const PAGE_LENGTH = 10

export const useGroupsData = ({
  filter,
  sorter,
  page = 1,
  pageLength = PAGE_LENGTH,
  membersFilter,
  membersSorter,
  membersPage = 1,
  membersPageLength = PAGE_LENGTH,
  skip = false,
}: Props) => {
  const queryVariables = React.useMemo(
    () => ({
      filterData: filter,
      pagination: {
        from: page * pageLength - pageLength,
        length: pageLength,
        sortBy: sorter?.sortBy || 'id',
        direction: sorter?.direction || SortDirectionEnum.DESC,
      },
      membersFilterData: membersFilter,
      membersPagination: {
        from: membersPage * pageLength - pageLength,
        length: membersPageLength,
        sortBy: membersSorter?.sortBy || 'id',
        direction: membersSorter?.direction || SortDirectionEnum.DESC,
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify({
        filter,
        sorter,
        page,
        pageLength,
        membersFilter,
        membersSorter,
        membersPage,
        membersPageLength,
      }),
    ]
  )
  const testSessionsQuery = useQuery<Groups, GroupsVariables>(GROUPS, {
    variables: queryVariables,
    skip,
  })

  return testSessionsQuery
}

export const useGroupsDataLazy = () => useLazyQuery<Groups, GroupsVariables>(GROUPS)
